import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import { ValoresEspecificos } from '@app/shared';

@Injectable()
export class CondictionColumnsDataService {
  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService) { }

  /**
   * Realiza la consulta de las columnas specificas de una maestra
   *
   * @param {*} structure
   * @returns {Promise<ValoresEspecificos[]>}
   * @memberof CondictionColumnsDataService
   */
  getColumnsSpecificMasterTable(structure: any): Promise<ValoresEspecificos[]> {
    return new Promise((resolve, reject) => {
      this.http.post<ValoresEspecificos[]>(this.api.get('masterTableSpecificInformation'),
        { estructura: structure }).subscribe(
          specificValues => {
            resolve(specificValues);
          },
          err => {
            reject(err);
          }
        );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/creation-form/condictions-columns/shared/condictions-columns.data.service.ts